import httpInstance from "../httpInstance";

export const postReservations = async (
  jwtToken: string,
  resourceId: number,
  start: string,
  finish: string,
  description?: string,
  comments?: string,
  id_before_update?: number,
  changed_by_admin?: boolean,
  changed_by_user?: boolean,
) => {
  let res: any;
  const endpoint = `reservations/`;

  // Configura el encabezado de autorización con el token JWT
  const config = {
    headers: {
      Authorization: `${jwtToken}`,
    },
  };

  // Configura el body
  const data = {
    resource: `${resourceId}`,
    start: `${start}`,
    finish: `${finish}`,
    description: `${description}`,
    comments: "Reserva creada por el usuario",
    id_before_update: `${id_before_update}`,
    changed_by_admin: false,
    changed_by_user: false,
  };

  await httpInstance
    .post(endpoint, data, config)
    .then((data) => {
      res = data;
    })
    .catch((error) => {
      res = error.response;
    });
  return res;
};
